"use client";

import useExternalSDK from "@/hooks/useExternalSDK";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "./ui/Spinner";

export default function AppleSignInAndUp({
  buttonText,
  callback,
  loading = false,
}) {
  const sdkReady = useExternalSDK(
    () => !!window.AppleID,
    () => {
      window.AppleID.auth.init({
        clientId: "com.turna.web.apple.login",
        scope: "name email",
        redirectURI: process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI,
        usePopup: true,
      });
    },
  );

  const handleAppleSignIn = async () => {
    try {
      const response = await window.AppleID.auth.signIn();
      const code = response.authorization.code;

      const res = await fetch("/api/auth/apple", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      });

      const data = await res.json();
      callback?.(data);
    } catch (error) {
      callback?.({ error: error?.message || "Apple sign in failed" });
    }
  };

  return (
    <button
      type="button"
      disabled={!sdkReady || loading}
      className="text-foreground border-primary-weak flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl border bg-white p-3 disabled:cursor-not-allowed disabled:opacity-50"
      onClick={handleAppleSignIn}
    >
      <FontAwesomeIcon
        icon={byPrefixAndName.fak["apple"]}
        className="text-2xl text-black"
      />
      <span className="font-medium">{buttonText}</span>
      {(!sdkReady || loading) && (
        <Spinner className="text-primary h-4 w-4 animate-spin" />
      )}
    </button>
  );
}
